import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  createTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteLocalidad,
  getLocalidadById,
  postLocalidad,
  updateLocalidad,
} from "../../../../api/localidad";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { checkIsEmpty } from "../../../../utils/helpers";
import { getProvincias } from "../../../../api/provincia";
import { Autocomplete } from "@material-ui/lab";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyCity() {
  return {
    fullName: "",
    provincia: "",
  };
}

export default function EditLocalidadesPage() {
  const [city, setCity] = useState(getEmptyCity());
  const [provinces, setProvinces] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const cityId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    getProvincias().then((res) => {
      setProvinces(res.data);
    });
    if (!cityId) {
      disableLoadingData();
      return;
    }
    getLocalidadById(cityId)
      .then((res) => {
        setCity(res.data);
        disableLoadingData();
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se ha podido obtener la ciudad.",
        });
        history.push("/cities");
      });
  }, [cityId, disableLoadingData, history]);

  function saveLocalidad() {
    if (checkIsEmpty(city.fullName))
      return alertError({
        error: null,
        customMessage: "El nombre es obligatorio.",
      });
    if (!cityId && !city.provincia)
      return alertError({
        error: null,
        customMessage: "Selecciona una provincia.",
      });
    if (!cityId) {
      postLocalidad(city)
        .then((res) => {
          alertSuccess({
            title: "Guardado!",
            customMessage: "City created correctamente.",
          });
          history.push("/cities");
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se ha podido guardar la ciudad.",
          });
        });
    } else {
      updateLocalidad(cityId, city)
        .then((res) => {
          alertSuccess({
            title: "Guardado!",
            customMessage: "Changes saved correctamente.",
          });
          history.push("/cities");
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se han podido guardar los cambios.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    setCity({ ...city, [element]: event.target.value });
  };

  if (isLoadingData)
    return <ContentSkeleton />;

  return (
    <>
      <Card>
        <CardHeader title="Editar ciudad"></CardHeader>
        <CardBody>
          <div className="d-flex align-item-center">
            <div className="col-4">
              <TextField
                label="Nombre"
                value={city.fullName}
                onChange={handleChange("fullName")}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
            <div className="col-4">
              <Autocomplete
                id='Provinces'
                options={provinces}
                value={city.provincia || null}
                getOptionLabel={(option) => option.fullName}
                onChange={(_, newValue) => {
                  setCity({
                    ...city,
                    provincia: newValue,
                  })
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Provincia'
                    margin="normal"
                    variant="outlined"
                  />
                )}
              />
            </div>
          </div>
        </CardBody>
      </Card>


      <Button
        onClick={() => history.push("/cities")}
        variant="outlined"
        style={{ marginRight: "20px" }}
      >
        Atrás
      </Button>

      <Button
        onClick={() => saveLocalidad()}
        variant="outlined"
        color="primary"
        style={{ marginRight: "20px" }}
      >
        Guardar ciudad
      </Button>

      {cityId && (
        <>
          <MuiThemeProvider theme={theme}>
            <Button
              onClick={() => setOpenConfirmDialog(true)}
              variant="outlined"
              color="secondary"
            >
              Eliminar ciudad
            </Button>
          </MuiThemeProvider>

          <ConfirmDialog
            title={"Seguro que quieres eliminar esta ciudad?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteLocalidad(cityId)
                .then((res) => {
                  alertSuccess({
                    title: "Eliminado!",
                    customMessage: "City deleted correctamente.",
                  });
                  history.push("/cities");
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar la ciudad.",
                  });
                });
            }}
          />
        </>
      )}
    </>
  );
}
